import React, {Component} from "react";
import {connect} from "react-redux";
import CarouselItem from "../../../../blocks/CarouselItem";
import Source from "../../../../items/Source";
import MiniLegend from "../../../../items/MiniLegend";

import {BarChart} from "d3plus-react";
import {textWidth} from "d3plus-text";
import {calculateDomain} from "../../../../../helpers/formatters";

class LaborMarketOutcomes extends Component {

  constructor(props) {
    super();
    this.state = {
      config1: {},
      config2: {},
      config3: {},
      config4: {},
      config5: {},
      colors: []
    };
    this.createConfigs = this.createConfigs.bind(this);
  }

  componentDidMount() {
    this.createConfigs(this.props.clustersData, this.props.selectedCluster,0);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.clustersData.length !== nextProps.clustersData.length){
      this.createConfigs(nextProps.clustersData, nextProps.selectedCluster, 0);
    }
    if (
      this.props.selectedCluster.id !== nextProps.selectedCluster.id
      ){
      this.createConfigs(nextProps.clustersData, nextProps.selectedCluster,300);
    }
    if (
      this.state.config1 !== nextState.config1 ||
      this.state.config2 !== nextState.config2 ||
      this.state.config3 !== nextState.config3 ||
      this.state.config4 !== nextState.config4 ||
      this.state.config5 !== nextState.config5
      ) {
      return true;
    }
    return false;
  }

  createConfigs(clustersData, selectedCluster, delayMS){

    const selectedClusterID = selectedCluster.id;
    const averageClusterID = 14;
    const clustersIds = [selectedClusterID, averageClusterID];

    const filteredData = clustersData.filter(cd => clustersIds.indexOf(cd.cluster_id) > -1);

    const colors = filteredData.map(d => ({color: d.color, label: d.cluster_name}));

    const varFormatters = [
      x => `${(x * 100).toFixed(1)}%`,
      x => `${(x * 100).toFixed(1)}%`,
      x => `${x.toFixed(0)}`,
      x => `${(x * 100).toFixed(0)}%`,
      x => `${x.toFixed(1)}%`,
    ];

    const longerNames = [
      "Net job growth 2007-18",
      "GDP per capita compound annual growth rate, 2007-18",
      "GDP per capita in Euros, thousands, 2013-18",
      "Employment rate 2018",
      "Unemployment rate 2018"
    ];

    const fields = {
      'net_job_growth_2011_18_in_percent': '<b>Net job growth</b>, 2011-18, %',
      'gdp_cagr_2013_2017': '<b>GDP CAGR</b>, 2013-17',
      'gdp_per_capita_eur': '<b>GDP per capita</b>, avg 2013-18, in thousands',
      'employment_rate_2018_share': '<b>Employment rate</b>, 2018, %',
      'unemployment_rate_2018_share': '<b>Unemployment rate</b>, avg 2013-18, %'
    };
    let longestStr = 0;
    let xMaxes = [0, 0, 0, 0, 0];
    let xMins = [0, 0, 0, 0, 0];
    let dataSets = Object.keys(fields).map((f, idx) => {
      if (fields[f].length > longestStr) {
        longestStr = Math.ceil(textWidth(fields[f]));
      }
      const finalData = [];
      let value;
      filteredData.forEach(fd => {
        value = fd[f];
        finalData.push({cluster_id: fd.cluster_id, cluster_name: fd.cluster_name, property: fields[f], value: value, color: fd.color});
        xMaxes[idx] = xMaxes[idx] < value ? value : xMaxes[idx];
        xMins[idx] = xMins[idx] > value ? value : xMins[idx];
      });
      return finalData;
    });
    let vizHeight = 78;
    let configs = dataSets.map((dataSet, idx) => {
      let myDomain = calculateDomain(xMins[idx], xMaxes[idx]);

      const chartConfigTemplate = {
        data: dataSet,
        groupBy: "cluster_name",
        discrete: "y",
        discreteCutoff: 0,
        legend: false,
        height: vizHeight,
        y: "property",
        x: "value",
        tooltipConfig: {
          body: d => `<div>${longerNames[idx]}: ${varFormatters[idx](d.value)}</div>`
        },
        yConfig: {
          title: false,
          minSize: 200,
          tickSize: 0
        },
        xConfig: {
          title: false,
          tickFormat: tick => `${varFormatters[idx](tick)}`,
          tickSize: 0,
          labels: myDomain.length > 0 ? [0] : [],
          domain: myDomain
        },
        shapeConfig: {
          Bar: {
            fill: d => d.color,
            duration: 0,
            label: (d) => (`${varFormatters[idx](d.value)}`)
          }
        },
        groupPadding: 0,
        barPadding: 2
      };
      if(delayMS>0){
        setTimeout(() => {
          this.setState({[`config${idx + 1}`]: chartConfigTemplate, colors:colors});
        }, delayMS * (idx + 1));
      }
      return chartConfigTemplate;

    });
    if (delayMS === 0) {
      this.setState({
        config1: configs[0],
        config2: configs[1],
        config3: configs[2],
        config4: configs[3],
        config5: configs[4],
        colors: colors
      });
    }
  }

  render() {
    const {clustersData} = this.props;
    if (clustersData.length === 0) {
      return '';
    }
    const {config1,config2,config3,config4,config5,colors} = this.state;
    return (
      <CarouselItem title="Labor market outcomes">
        <div className="fow-col fow-col-1">
          <MiniLegend colors={colors} />
          <BarChart config={config1} />
          <BarChart config={config2} />
          <BarChart config={config3} />
          <BarChart config={config4} />
          <BarChart config={config5} />
          <Source text="Source: Oxford Economics, Eurostat; McKinsey Global Institute analysis" />
        </div>
      </CarouselItem>
    );
  }
}

const mapStateToProps = state => {
  return {
    clustersData: state.db.data.dimensions.clusters ? state.db.data.dimensions.clusters : [],
    selectedCluster: state.settings.map["Clusters"]
  };
};
const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(LaborMarketOutcomes);
